export default __webpack_public_path__ + "a687dd7ac15e3184e47dde3b3aeb9d98.svg";